import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "Technology", href: "#technology" },
  { label: "Industries", href: "#industries" },
  { label: "Mission", href: "#mission" },
  { label: "About", href: "#about" },
];

const Navbar = ({ onScrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    onScrollTo(href);
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-[100] transition-colors duration-300 ${
        scrolled ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#27272a]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 bg-[#ff4500] group-hover:rotate-45 transition-transform duration-300" />
          <span className="font-display text-xl font-semibold tracking-tight text-[#f5f5f5]">
            ErgoAssist
          </span>
        </button>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="font-mono-accent text-[13px] tracking-wide text-[#a1a1aa] hover:text-[#f5f5f5] transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-demo"
            onClick={() => go("#contact")}
            className="group relative bg-[#ff4500] text-white px-5 py-2.5 font-mono-accent text-[13px] tracking-wide hover:bg-[#e03e00] active:scale-95 transition-all duration-200"
          >
            Request a Demo
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Menu"
        >
          <span className={`w-6 h-0.5 bg-[#f5f5f5] transition-transform ${open ? "translate-y-2 rotate-45" : ""}`} />
          <span className={`w-6 h-0.5 bg-[#f5f5f5] transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`w-6 h-0.5 bg-[#f5f5f5] transition-transform ${open ? "-translate-y-2 -rotate-45" : ""}`} />
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#0a0a0a] border-t border-[#27272a] px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-left font-display text-2xl text-[#f5f5f5]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta-demo"
            onClick={() => go("#contact")}
            className="bg-[#ff4500] text-white px-5 py-3 font-mono-accent text-sm mt-2"
          >
            Request a Demo
          </button>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
